export default {
  store: 2,
  // slider: "C07F2A0D-3B8F-4219-A94A-DBD68EA03045",
  slider: 4,
  // categorys: "6afe8aa1-875d-4414-9a47-1ec59381e624",
  categorys: 2,
}
